import { render, staticRenderFns } from "./StudentPhoto.vue?vue&type=template&id=67f9b872"
import script from "./StudentPhoto.vue?vue&type=script&lang=js"
export * from "./StudentPhoto.vue?vue&type=script&lang=js"
import style0 from "./StudentPhoto.vue?vue&type=style&index=0&id=67f9b872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports